import { useEffect } from 'react';

const OAuthPopupHandler = () => {
  useEffect(() => {
    // Extract token and state from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code'); // Or "code" if using authorization code flow
    const state = urlParams.get('state');

    if (!code || !state) {
      console.error('No code or state found!');
      window.close();
      return;
    }

    // @NOTE: This is a unsafe implementation
    // @TODO: Implement a secure way to send the token and state back to the main window
    // The commented lines below are a more secure way to send the token and state back to the main window
    // but for some reasons it's not working as expected
    // set into local storage
    localStorage.setItem('rally_wf_en_gm_code', code);
    localStorage.setItem('rally_wf_en_gm_state', state);
    window.close();

    // if (window.opener) {
    //   // Send token and state back to the main window
    //   window.opener.postMessage({ code, state }, window.location.origin);
    //   // Close the popup
    //   window.close();
    // } else {
    //   console.error('No opener found!');
    // }
  }, []);

  return (
    <div>
      <h1>Authenticating with google ...</h1>
    </div>
  );
};

export default OAuthPopupHandler;
